var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsBoolean, IsDateString, IsEnum, IsNotEmpty, IsNumberString, IsOptional, IsString, IsUUID, Length } from "class-validator";
import { GFIDProvider } from "./healthcareorganization.dtos";
export const VERIFICATION_DEFAULT_MAX_ATTEMPTS = 5;
export const VERIFICATION_DEFAULT_OTP_LENGTH = 6;
export const VERIFICATION_COOLDOWN_SECONDS = 30;
export var VerificationPurpose;
(function (VerificationPurpose) {
    VerificationPurpose["PATIENT_PHONE_NUMBER"] = "PATIENT_PHONE_NUMBER";
})(VerificationPurpose || (VerificationPurpose = {}));
export class FetchPendingVerificationInput {
}
__decorate([
    IsUUID()
], FetchPendingVerificationInput.prototype, "verificationKey", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], FetchPendingVerificationInput.prototype, "oauthState", void 0);
export class FetchPendingVerificationResponse {
}
__decorate([
    IsString(),
    IsOptional()
], FetchPendingVerificationResponse.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional()
], FetchPendingVerificationResponse.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional()
], FetchPendingVerificationResponse.prototype, "dateOfBirth", void 0);
__decorate([
    IsString(),
    IsOptional()
], FetchPendingVerificationResponse.prototype, "phoneNumber", void 0);
__decorate([
    IsBoolean()
], FetchPendingVerificationResponse.prototype, "phoneVerified", void 0);
__decorate([
    IsBoolean()
], FetchPendingVerificationResponse.prototype, "isExistingUser", void 0);
__decorate([
    IsEnum(GFIDProvider)
], FetchPendingVerificationResponse.prototype, "gfidProvider", void 0);
__decorate([
    IsBoolean()
], FetchPendingVerificationResponse.prototype, "showAccountSetup", void 0);
export class CompleteVerificationInput {
}
__decorate([
    IsUUID()
], CompleteVerificationInput.prototype, "verificationKey", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], CompleteVerificationInput.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], CompleteVerificationInput.prototype, "lastName", void 0);
__decorate([
    IsDateString()
], CompleteVerificationInput.prototype, "dateOfBirth", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], CompleteVerificationInput.prototype, "phone", void 0);
export class VerificationSendInput {
}
__decorate([
    IsUUID()
], VerificationSendInput.prototype, "verificationKey", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], VerificationSendInput.prototype, "phone", void 0);
__decorate([
    IsEnum(VerificationPurpose)
], VerificationSendInput.prototype, "purpose", void 0);
export class VerificationVerifyInput {
}
__decorate([
    IsUUID()
], VerificationVerifyInput.prototype, "verificationKey", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], VerificationVerifyInput.prototype, "phone", void 0);
__decorate([
    IsNumberString({}, { message: "Verification code must contain only numbers" }),
    Length(VERIFICATION_DEFAULT_OTP_LENGTH, VERIFICATION_DEFAULT_OTP_LENGTH, {
        message: `Verification code must be exactly ${VERIFICATION_DEFAULT_OTP_LENGTH} digits`,
    })
], VerificationVerifyInput.prototype, "code", void 0);
__decorate([
    IsEnum(VerificationPurpose)
], VerificationVerifyInput.prototype, "purpose", void 0);
